import { Injectable } from "@angular/core";
import { BehaviorSubject, Observer, Subject } from "rxjs";
import { ApiService } from "../services/api-service";
import { ApiServiceDelegate } from "../services/api-service-delegate";
import { ApiCollection } from "../services/api-collection";
import { AppCommon } from "../app-common";
import { LoginModel, NotificationResponseModal } from "../models/login.model";
import { LoginComponent } from "src/app/login/login.component";
import { NzMessageService } from "ng-zorro-antd/message";

@Injectable({
    providedIn: "root",
})

export class LoginViewModel {

    parentLoginComponent: LoginComponent; 
    loginModel = new BehaviorSubject<LoginModel>(new LoginModel());
    private notificationResponseModal = new BehaviorSubject<NotificationResponseModal>({
        count: 0,
        next: null,
        previous: null,
        results: []
      })
    notification$ = this.notificationResponseModal.asObservable()
    notificationUpdated = new Subject()
    notificationUpdated$ = this.notificationUpdated.asObservable()
    notificationCleared = new Subject()
    notificationCleared$ = this.notificationCleared.asObservable()
    constructor(
        private apiService: ApiService,
        private message: NzMessageService
    ) {
        
    }
 

    subscribeLogin(
      observer: Observer<LoginModel>
    ){
      this.loginModel.subscribe(observer)
    }
 

    authenticate(token){
        let d: ApiServiceDelegate = {
            Data: { token: token },
            Method: "POST",
            Action: ApiCollection.GOOGLE_SIGN_IN,
            Success: (e: any) => {
                if (e.status === true) {
                    AppCommon.setLoggedInObject(e);
                    this.loginModel.next(e);
                    this.parentLoginComponent.loginSuccess();
                    this.message.success("Logged in successfully", {nzDuration: 1000});
                } else {
                    this.message.error("Login error", {nzDuration: 1000});
                    console.log("login error");
                }
            return e;
            },
            Error: (e: String) => {
                this.parentLoginComponent.loginSuccess();
            return e;
            },
        };
        this.apiService.callService(d);
    }


    getNotification(user,page_size,page){
        let str =   ApiCollection.NOTIFICATION + '?page='+page +'&page_size='+page_size  
        // if(user.roles !== 'SuperAdmin'){
        if(user.roles !==  null){
            str += '&user=' + user.id
        }
         
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action:str  ,
            Success: (e: any) => {
                this.notificationResponseModal.next(e)
            //  console.log(e)
            // this.message.success("Logged in successfully", {nzDuration: 1000});
                 
            return e;
            },
            Error: (e: String) => {
                // this.parentLoginComponent.loginSuccess();
            return e;
            },
        };
        this.apiService.callService(d);
    }

    updateNotification(user,is_read,id){
        let d: ApiServiceDelegate = {
            Data: {user:user,is_read:is_read},
            Method: "PATCH",
            Action: ApiCollection.NOTIFICATION +'/'+ id ,
            Success: (e: any) => {
            this.notificationUpdated.next(true)
            this.message.success("Notification read status updated!", {nzDuration: 1000});
                 
            return e;
            },
            Error: (e: String) => {
                // this.parentLoginComponent.loginSuccess();
            return e;
            },
        };
        this.apiService.callService(d);
    }
    clearAllNotification(user){
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "DELETE",
            Action: ApiCollection.NOTIFICATION +'/clear_all' + '?user=' + user.id,
            Success: (e: any) => {
            this.notificationCleared.next(true)
            this.message.success("All notification cleared for you!" , {nzDuration: 1000});
                 
            return e;
            },
            Error: (e: String) => {
                // this.parentLoginComponent.loginSuccess();
            return e;
            },
        };
        this.apiService.callService(d);
    }

}
